import { Dropzone, IconUpload } from '@ui/src';
import { DocumentUploadTypes } from './types';

import cn from './styles.module.css';

const UploadDocument = ({
  onUpload,
  uploadInputRef,
  fileUploadInProgress,
  uploadError,
  uploadDocumentError,
}: DocumentUploadTypes) => (
  <div className={cn.uploadFileWrapper}>
    <Dropzone
      dropzoneIcon={
        <div className={cn.dropzoneButtonWrapper}>
          <div className={cn.dropzoneButtonTitle}>Upload transaction file</div>
          <div className={cn.dropzoneButton}>
            <IconUpload /> Select file
          </div>
        </div>
      }
      inputRef={uploadInputRef}
      onUpload={onUpload}
      fileUploadInProgress={fileUploadInProgress}
      dropzoneText=".xls"
      dropzoneClassName={cn.dropzoneWrapper}
      dropzoneTextClassName={cn.dropzoneAcceptText}
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    />
    {uploadDocumentError && (
      <div className={cn.uploadError}>
        - The document <strong>{uploadDocumentError.name}</strong> was not
        uploaded.
        <br />
        <span>
          <strong>Reason:</strong> {uploadDocumentError.error}
        </span>
      </div>
    )}

    {uploadError && <div className={cn.uploadError}>{uploadError}</div>}
  </div>
);

export default UploadDocument;
